export default __webpack_public_path__ + "static/media/Snd3.8fc07b5b.mp3";